export default class Avulso {
  constructor(id, descricao, data, faturado, concluido) {
    this.id = id;
    this.descricao = descricao;
    this.data = data;
    this.faturado = faturado;
    this.concluido = concluido;
  }

  update(avulso) {
    this.id = avulso.id;
    this.descricao = avulso.descricao;
    this.data = avulso.data;
    this.faturado = avulso.faturado;
    this.concluido = avulso.concluido;
  }
}
